import { DefaultPrinciples } from "@/pages/settings/reviewer/defaultPrinciples"
import { Tabs, TabsList, TabsTrigger } from "@/components"
import { useTranslation } from "react-i18next"
import { CustomPrinciples } from "@/pages/settings/reviewer/customPrinciples"
import { useFetchFeatureFlags } from "@/hooks/queries/useFetchFeatureFlags.tsx"
import { useMemo } from "react"

export function Preferences() {
  document.title = "Settings - Preferences"
  const defaultValue = "default"
  const { t } = useTranslation("Settings")

  const { data, isLoading } = useFetchFeatureFlags()

  const customReviewerEnabled = useMemo(() => {
    if (isLoading || !data) {
      return false
    }

    return data["enable_principles_generation"] === true
  }, [data, isLoading])

  return (
    <section>
      <Tabs defaultValue={defaultValue}>
        {customReviewerEnabled ? (
          <TabsList className="grid w-[289px] grid-cols-2 gap-1 bg-darker-fill p-1">
            <TabsTrigger value="default">{t("DefaultReviewers")}</TabsTrigger>
            <TabsTrigger value="custom">{t("CustomReviewers")}</TabsTrigger>
          </TabsList>
        ) : null}
        <CustomPrinciples />
        <DefaultPrinciples />
      </Tabs>
    </section>
  )
}
